import usePaceLandingLayout from "./usePaceLandingLayout";
import useRedirectOnNoPersonId from "utils/hooks/useRedirectOnNoPersonId";

// Components
import { PaceLandingWelcomeLayout } from "./PaceLandingLayoutComponents";

// Others
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAppDispatch } from "app/hooks";
import { toggleLoader } from "store/slice/UI";
import { useAuth } from "utils/hooks";

const PaceLandingLayout = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    // Redirect to Dashboard if no personId on Session
    useRedirectOnNoPersonId();

    const { loggedInUserData } = useAuth();
    const {
        isNewAssessment,
        paceAssessmentStatus,
        hasOnGoingAssessment,
        paceAssessmentRequestStatus,
        handleStartPace,
    } = usePaceLandingLayout();

    const showContent = paceAssessmentRequestStatus === "done";

    useEffect(() => {
        if (paceAssessmentRequestStatus === "fetching") {
            dispatch(toggleLoader(true));
        }

        if (paceAssessmentRequestStatus === "done" || paceAssessmentRequestStatus === "error") {
            dispatch(toggleLoader(false));
        }

        if (paceAssessmentStatus?.user_assessments.length && !hasOnGoingAssessment) {
            const lastAssessment = paceAssessmentStatus?.user_assessments[0];
            navigate(`/pace/report/user/${loggedInUserData.userId}/assessment/${lastAssessment.user_assessment_id}`);
        }
    }, [
        dispatch,
        navigate,
        hasOnGoingAssessment,
        loggedInUserData.userId,
        paceAssessmentRequestStatus,
        paceAssessmentStatus?.user_assessments,
    ]);

    return showContent ? (
        <PaceLandingWelcomeLayout isNewAssessment={isNewAssessment} handleStartPace={handleStartPace} />
    ) : (
        <></>
    );
};

export default PaceLandingLayout;
